const routerLinks = {
  ////////////////////////////
  homePage: '/',
  ////////////////////////////
  ////////////////////////////////
  contactPage: '/register',
  OtpVerification: '/verification',
  PolicyPage: '/Policy',
  ConditionPage: '/Condition',
  returnPage: '/return',
  daftarPage: '/daftar',
  payPage: '/pay',
  HelpFatorah: '/Help',
  blogPage: '/Blog',
  ////////////////////////////
  ////////////////////////////////
  ErrorPage: '/errorPage',
};

export default routerLinks;
